/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
import cancelIcon from '../../../../assets/images/cancel-icon.svg';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { MFG_Select_LabelerHead } from './gridComponents/tableHead';
import { validDate } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  MinDate,
  MaxDate,
} from '../../../../SharedModules/CommonConstants/commonConstants';

import {
  getSearchLabelers,
  maintainLabelerListData,
} from '../store/ManufacturerAction';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import PDFExportPanel from '../../../../SharedModules/pdfExport/PDFExportPanel';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';

export default function SelectNewLabelerModal(props) {
  const dispatch = useDispatch();
  const { dataList, open } = props;
  const addEditManufacturerLabelersData = (value, action) => {
    dispatch(maintainLabelerListData(value, action));
  };
  const [startDate, setStartDate] = useState(null);
  const [error, setError] = useState('');
  const [errorSelectRow, setErrorSelectRow] = useState('');
  const childRef = React.useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [rowData, setRowData] = useState(dataList);
  const [columnDefs] = useState(MFG_Select_LabelerHead);
  const [spinnerLoader, setSpinnerLoader] = useState(true);
  // set onload event form values
  React.useEffect(() => {
    setError('');
    //setSpinnerLoader(false);
    setErrorSelectRow('');
    setRowData(dataList);
  }, [dataList]);
  React.useEffect(() => {
    setError('');
    setSpinnerLoader(false);
    setErrorSelectRow('');
    setStartDate(null);
  }, []);
  const fetchDataFromServer = (data) => {
    dispatch(getSearchLabelers(data));
  };
  // click on select button after call
  const onSubmit = () => {
    let showError = false;
    if (startDate === null) {
      showError = true;
      setError(constantMessageData.START_DATE_REQUIRED);
    } else if (validDate(new Date(startDate)) === false) {
      showError = true;
      setError(constantMessageData.DATE_INVALID_FORMAT_ERROR);
    }
    if (!showError) {
      setError('');
      setSpinnerLoader(true);
      dispatch(getSearchLabelers(null));
      fetchDataFromServer({
        startDt: moment.utc(startDate).format('MM/DD/yyyy'), //moment(startDate).format('MM-DD-yyyy'),
      });
    }
  };
  // call on Blur event filed level
  const onBlurDateEvent = (d, event) => {
    if (d != 'Invalid Date') {
      let value = null;
      if (event === 'onBlur' && d.target.value && d.target.value.length > 5) {
        const data = d.target.value.split('/');
        if (data[2].split('_').length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          value = d.target.value;
        }
      } else {
        value = event === 'onBlur' ? d.target.value : d;
      }
      let showError = false;
      if (value === null) {
        showError = true;
        setError(constantMessageData.START_DATE_REQUIRED);
      } else if (validDate(new Date(value)) === false) {
        showError = true;
        setError(constantMessageData.DATE_INVALID_FORMAT_ERROR);
      } else if (compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))) {
        showError = true;
        setError(constantMessageData.MFG_START_DATE_ERROR);
      }
      if (!showError) {
        setError('');
        setStartDate(value);
      }
    }
  };
  // check validation after call
  const addNewLabelers = () => {
    setError('');
    setErrorSelectRow('');
    props.handleClose();
    let newObj = [];
    newObj =
      rowData &&
      rowData.length > 0 &&
      rowData
        .filter((x) => {
          return x.value;
        })
        .map((prop) => {
          return {
            labelerCode: prop.labelerCode,
            labelerName: prop.labelerName,
            actionVal: 0,
            startDate: moment.utc(startDate).format('MM/DD/yyyy'),
            endDate: '',
            lastUpdateUserId: null,
            corrLinkId: null,
            MFG_ID: null,
            mfgTypeCd: 'C',
            isAddedFromUI: null,
            startDateErr: false,
            endDateErr: false,
            ccCommentsExist: 0,
          };
        });
    addEditManufacturerLabelersData(newObj);
    setStartDate(null);
    props.handleClose(false);
  };
  React.useEffect(() => {
  if (dataList && dataList.length > 0) {
    setSpinnerLoader(false);
  }
}, [dataList]);
  // close popup function
  const handleClose = () => {
    props.handleClose(props.disabledSaveCancelBtn);
    setStartDate(null);
  };
  // ag-grid frame work component
  const frameworkComponents = {
    CheckBox: (cellInfo) => {
      return (
        <>
          <div className="tbl-checkbox">
            <FormControlLabel
              data-testid="checkbox-filed"
              control={<Checkbox color="primary" />}
              onClick={(e) => {
                const { checked } = e.target;
                const { colId } = cellInfo.column;
                cellInfo.node.setDataValue(colId, checked);
              }}
              checked={cellInfo.value}
              value={cellInfo.value}
            />
          </div>
        </>
      );
    },
    labelerNameRender: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.labelerName;
      if (name && name.length > 30) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };
  return (
    <div id="copy-contact-popup">
      <Dialog
        open={open}
        data-testid="mfg-select-commercial-labeler-popup"
        maxWidth="md"
        className="inbuilt-dialog dialogPanel custom-check dialog-600"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className="copy-contact-title"
          style={{ cursor: 'move' }}
          id="draggable-dialog-title"
        >
          <div className="float-left dialog-heading-txt">
            Select Labelers for this Manufacturer
          </div>
          <div
            className="close-popup-icon float-right"
            role="button"
            data-testid="handleClosePopup"
            onClick={handleClose}
          >
            <img alt="" src={cancelIcon} />
          </div>
          <div className="clearfix" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {spinnerLoader && <Spinner load={spinnerLoader} />}
            <div style={{ margin: '15px' }}>
              <fieldset className="custom-fieldset" style={{ display: 'flex' }}>
                <legend className="same-font-family">Start Date</legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form input-md no-lbl">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <label
                    className='m-0 visually-hidden'
                    htmlFor="begin_date_net_association_bp_tab"
                    >
                    <span>label</span>{' '}
                    </label>
                      <KeyboardDatePicker
                        required
                        id="begin_date_net_association_bp_tab"
                        className="mandate-fields"
                        data-testid="start-date"
                        label={false}
                        format="MM/dd/yyyy"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: false,
                          autoFill: false,
                        }}
                        placeholder="mm/dd/yyyy"
                        minDate={MinDate}
                        maxDate={MaxDate}
                        mask="__/__/____"
                        value={startDate}
                        onChange={(d) => {
                          setStartDate(d);
                          onBlurDateEvent(d);
                        }}
                        onBlur={(e) => {
                          onBlurDateEvent(e, 'onBlur');
                        }}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        helperText={error}
                        error={error}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="btn-wrapper">
                      <Button
                        className="btn btn-success btn-search ml-0"
                        data-testid="search-btn"
                        type="button"
                        onClick={() => {
                          onSubmit();
                        }}
                      >
                        <SVGComponent iconName="Icon-search" />
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              </fieldset>
              {spinnerLoader ? (
                <Spinner />
              ) : dataList && dataList.length > 0 ? (
                <TableGrid
                  gridHeight={350}
                  rowData={rowData?.map((item) => {
                    item.value = item.value === 'true' || item.value ? 1 : 0;
                    return item;
                  })}
                  columnDefs={columnDefs}
                  navigateToNextCell={navigateToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                  childPopup
                  applyFilter={false}
                  exportFile
                  helpMessage="* Labelers not currently Associated with Commercial Manufacturer"
                  data-testid="onEditingStopped"
                  fileName="Manufacturer-Labelers"
                  frameworkComponents={frameworkComponents}
                />
              ) : null}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="MuiFormHelperText-root Mui-error Mui-required">
            {errorSelectRow}
          </div>
          <div className="btn-wrapper mb-2">
            <Button
              className="btn btn-success btn-search mr-3"
              type="button"
              data-testid="select-labeler-btn"
              onClick={() => {
                if (
                  rowData &&
                  rowData.length > 0 &&
                  rowData.filter((x) => {
                    return x.value;
                  }).length > 0
                ) {
                  setErrorSelectRow('');
                  addNewLabelers();
                } else {
                  setErrorSelectRow(
                    'Please select at least one labeler to add.'
                  );
                }
              }}
            >
              <SVGComponent iconName="Icon_awesome-check-circle" /> Select
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
